<template>
  <div>
    <v-app>
    <my-asidebar v-bind:active-tab="'accesslogs'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Access Logs </h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/roleright'" class="text-white">Erişim Kayıtları</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-main-content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <form id="portForm">
                  <div class="form-box" v-if="accessLogsResponse">
                    <div class="form-title-wrap">
                      <div class="row" >
                        <v-pagination
                            v-model="currentPage"
                            :length="accessLogsResponse.maxPage+1"
                        ></v-pagination>
                      </div>
                      <div class="row justify-content-left ml-2 mt-7 mb-2">
                        <div class="input-box">
                          <button class="theme-btn" type="button" @click="setSearchTerm()">Ara</button>
                        </div>
                        <div class="input-box mt-1 ml-2">
                          <input class="form-control" v-model="newSearchTerm" id="paymentAmount" type="text" placeholder="">
                        </div>
                        <label class="ml-2 mt-2 font-weight-bold"> Email </label>
                        <input class="form-control mt-1 ml-0" style="padding-left:0px;height:30px;width: 5rem;" type="checkbox"
                               v-model="searchAreaEmail">

                        <label class="ml-2 mt-2 font-weight-bold"> Request </label>
                        <input class="form-control mt-1 ml-0" style="padding-left:0px;height:30px;width: 5rem;" type="checkbox"
                               v-model="searchAreaRequest">

                        <label class="ml-2 mt-2 font-weight-bold"> Response </label>
                        <input class="form-control mt-1 ml-0" style="padding-left:0px;height:30px;width: 5rem;" type="checkbox"
                               v-model="searchAreaResponse">

                        <label class="ml-2 mt-2 font-weight-bold"> Role </label>
                        <input class="form-control mt-1 ml-0" style="padding-left:0px;height:30px;width: 5rem;" type="checkbox"
                               v-model="searchAreaRole">

                        <label class="ml-2 mt-2 font-weight-bold"> Url </label>
                        <input class="form-control mt-1 ml-0" style="padding-left:0px;height:30px;width: 5rem;" type="checkbox"
                               v-model="searchAreaUrl">
                      </div>
                    </div>
                    <access-logs-list/>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </v-app>
  </div>
</template>

<script>
import PortDetail from "../component/port/PortDetail";
import MyAsidebar from "../component/common/MyAsidebar";
import TopBar from "../component/common/TopBar";
import messagePopupManager from "../util/messagePopupManager";
import AccessLogsList from "../component/auth/AccessLogsList";

export default {
  name: "AccessLogsPage",
  components: {AccessLogsList, TopBar, MyAsidebar,  PortDetail},
  data () {
    return {
      rightList: [],
      currentPage: 1,
      searchTerm : "",
      newSearchTerm : "",
      searchAreaEmail : true,
      searchAreaRequest : true,
      searchAreaResponse : true,
      searchAreaRole : true,
      searchAreaUrl : true
    }
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    },
    accessLogsResponse : {
      get(){
        return this.$store.getters.getAccessLogsResponse;
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_ACCESS_LOGS"]) this.$router.push("/");
    this.loadAccessLogs();
  },
  methods: {
    loadAccessLogs(){
      let searchAreas = "";
      if(this.searchAreaEmail) {
        searchAreas += "email"
      }
      if(this.searchAreaRequest) {
        if(!searchAreas.endsWith(",")){
          searchAreas += ",";
        }
        searchAreas += "request"
      }
      if(this.searchAreaResponse) {
        if(!searchAreas.endsWith(",")){
          searchAreas += ",";
        }
        searchAreas += "response"
      }
      if(this.searchAreaRole) {
        if(!searchAreas.endsWith(",")){
          searchAreas += ",";
        }
        searchAreas += "role"
      }
      if(this.searchAreaUrl) {
        if(!searchAreas.endsWith(",")){
          searchAreas += ",";
        }
        searchAreas += "url"
      }

      this.$store.dispatch("loadAccessLogs",{searchTerm: this.searchTerm, searchAreas: searchAreas, page:this.currentPage-1}).then(response =>{
      });
    },
    setSearchTerm(){
      this.searchTerm = this.newSearchTerm;
      this.loadAccessLogs();
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.loadAccessLogs();
      }
    }
  }
}
</script>

<style scoped>

</style>